import React, { useState } from 'react';
import ReactTooltip from 'react-tooltip';
import {
  Table, Text, TouchableOpacity,
} from '../../../app-components';
import { unsubNotiListUri } from '../../../Queries/manageNoti';
import vars from '../../../theme/vars';
import { shorten } from '../../../Lib/helpers';
import { invoke } from '../../../AppServices';

const { headings } = vars;

const StatusButton = ({ item, navigation }) => {
  const [h, setH] = useState(false);

  const decideColor = () => {
    if (item ) {
      return h ? 'rgb(118,215,196)' : 'rgb(72,201,176)';
    }
    return h ? 'rgb( 248, 196, 113 )' : 'rgb( 245, 176, 65 )';
  };

  const bgColor = decideColor();

  return (
    <>
      <ReactTooltip place="bottom" type="dark" effect="float" id={item._id} />
      <div data-tip="Toggle Status" data-for={item._id}>
        <TouchableOpacity
          onMouseOver={() => setH(true)}
          onFocus={() => setH(true)}
          onMouseLeave={() => setH(false)}
          style={{
            width: 160,
            borderRadius: 15,
            backgroundColor: bgColor,
            alignItems: 'center',
            paddingTop: 7,
            paddingBottom: 7,
          }}
          onPress={async () => {
            const routeName = navigation?.state?.routeName;
            const { email, phoneNumber } = item;

            await invoke({
              id: 'addRecordInNotificationsUnsubs',
              paramValue: {
                data: {
                  email: email ? email : "",
                  phoneNumber: phoneNumber ? phoneNumber : "",
                  action: "sub"
                },
              },
            });
            navigation.reset(routeName);
          }}
        >
          <Text style={{ ...headings.h8, color: 'white', cursor:"pointer" }}>
            Subscribe again
          </Text>
        </TouchableOpacity>
      </div>
    </>
  );
};

const tableItems = {
  lg: {
    columns: [
      {
        header: 'Sr #',
        width: 200,
        render: ({ index }) => (
          <Text style={{ fontSize: 16, fontFamily: 'Mulish-Medium' }}>
            {index + 1}
          </Text>
        ),
      },
      {
        header: 'Email',
        width: 300,
        render: ({ item = {} }) => (
          <Text style={{ fontSize: 16, fontFamily: 'Mulish-Medium' }}>
            {shorten(item?.email, 40)}
          </Text>
        ),
      },
      {
        header: 'Phone Number',
        width: 300,
        render: ({ item = {} }) => (
          <Text style={{ fontSize: 16, fontFamily: 'Mulish-Medium' }}>
            {shorten(item?.phoneNumber?.toString(), 25)}
          </Text>
        ),
      },

      {
        header: 'Status',
        width: 300,
        render: ({ item, navigation }) => (
          <StatusButton item={item} navigation={navigation} />
        ),
      },
    ],
  },
};

export default Table({
  reloadEvent: 'NotiListReload',
  uri: unsubNotiListUri,
  ...tableItems,
});
